import { Permisos } from '@/shared/constants/permisos';
import type { TourDefinicion } from '@/features/guia-interactiva/types/guia-interactiva.types';

export const tourSeguridadUsuarios: TourDefinicion = {
  codigo: 'seguridad-usuarios',
  titulo: 'Usuarios',
  descripcion: 'Gestión de cuentas de usuario del sistema.',
  ruta: '/admin/seguridad/usuarios',
  permisoMenu: Permisos.USUARIOS_MENU,
  pasos: [
    {
      id: 'seguridad-usuarios:header',
      selector: '[data-testid="seguridad-usuarios.header"]',
      titulo: 'Usuarios',
      descripcion:
        'Administra las cuentas del sistema: creación, edición, activación y asignación de roles.',
      side: 'bottom',
      align: 'start',
    },
    {
      id: 'seguridad-usuarios:boton-crear',
      selector: '[data-testid="seguridad-usuarios.boton-crear"]',
      titulo: 'Nuevo usuario',
      descripcion: 'Registra un usuario nuevo asignándole roles y foto desde el formulario.',
      permisoRequerido: Permisos.USUARIOS_CREAR,
      side: 'left',
      align: 'center',
    },
    {
      id: 'seguridad-usuarios:tabla',
      selector: '[data-testid="seguridad-usuarios.tabla"]',
      titulo: 'Listado',
      descripcion:
        'Busca por nombre o email y usa las acciones de cada fila para editar o desactivar.',
      side: 'top',
      align: 'center',
    },
  ],
};
